import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ContextualFlatTeamSettingGroupId = "contextual.general";

const contextualOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.contextual",
  product: "integrations",
};

const contextualRisk: SettingRisk = {
  level: "medium",
  reason:
    "Controls whether the Contextual SDK loads on the storefront and which host it loads from.",
};

export const ContextualFlatTeamSettingGroups = [
  {
    id: "contextual.general",
    title: "Contextual",
    description:
      "The Contextual integration: whether it runs for this team, the subdomain it serves from, and the onboarding state recorded while that subdomain is set up.",
    productArea: "integrations",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: contextualOwner,
    risk: contextualRisk,
    agentEditability: { mode: "requiresApproval" },
    synonyms: ["contextual", "contextual domain", "ctx domain"],
  },
] as const satisfies readonly SettingGroupDefinition<ContextualFlatTeamSettingGroupId>[];

export const ContextualFlatTeamSettingGroupById = (() => {
  const map: Record<
    string,
    SettingGroupDefinition<ContextualFlatTeamSettingGroupId>
  > = {};
  for (const group of ContextualFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    ContextualFlatTeamSettingGroupId,
    SettingGroupDefinition<ContextualFlatTeamSettingGroupId>
  >;
})();
